class FetchFacilities {
	constructor(public readonly organizationId: number) {
		Object.freeze(this);
	}
}

export default FetchFacilities;
